import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-text",
  "use": "icon-text-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-text\"><defs><style type=\"text/css\"></style></defs><path d=\"M214.101333 283.861333a42.666667 42.666667 0 1 1 0-85.333333h640a42.666667 42.666667 0 1 1 0 85.333333h-277.333333v554.666667a42.666667 42.666667 0 1 1-85.333333 0v-554.666667h-277.333334z\" p-id=\"3284\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol